import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL } from "./api";

const ContentCtx = createContext({ c: {}, reload: () => {} });

export function ContentProvider({ children }) {
  const [c, setC] = useState({});
  const reload = useCallback(() => api.get("/content").then(r => setC(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentCtx.Provider value={{ c, reload }}>{children}</ContentCtx.Provider>;
}

export const useContent = () => useContext(ContentCtx);

// Uploaded assets are stored as "/api/media/..." paths; external images as full URLs
export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

// Renders text, coloring every "/" with the given accent class
export function Slashed({ text = "", className = "text-neon" }) {
  const parts = text.split("/");
  return parts.map((p, i) => (
    <React.Fragment key={`${i}-${p}`}>{p}{i < parts.length - 1 && <span className={className}>/</span>}</React.Fragment>
  ));
}
